import axios from 'axios';
import {
  FETCHING_REPORT,
  FETCH_REPORT_SUCCESS,
  FETCHING_REPORTS_TEMPLATES,
  FETCH_REPORTS_TEMPLATES_SUCCESS,
  GENERATING_REPORT,
  GENERATE_REPORT_SUCCESS,
  DOWNLOADING_REPORT,
  DOWNLOAD_REPORT_SUCCESS
} from "./ReportConstants";
import { downloadFile } from 'redux/files/FilesActions';

const path = 'utm/v1/reports';
const assetPath = 'v1/s1/assets';

const fetchingReports = (pageState) => ({ type: FETCHING_REPORT, pageState });
const fetchReportsSuccess = (reports, pageState) => ({ type: FETCH_REPORT_SUCCESS, reports, pageState });
const fetchingReportsTemplates = () => ({ type: FETCHING_REPORTS_TEMPLATES });
const fetchReportsTemplateSuccess = reportsTemplates => ({ type: FETCH_REPORTS_TEMPLATES_SUCCESS, reportsTemplates });
const generatingReport = () => ({ type: GENERATING_REPORT });
const generateReportSuccess = () => ({ type: GENERATE_REPORT_SUCCESS });
const downloadingReport = () => ({ type: DOWNLOADING_REPORT });
const downloadReportSuccess = () => ({ type: DOWNLOAD_REPORT_SUCCESS });

const fetchReports = (page = 0, perPage = 10) => dispatch => {
  dispatch(fetchingReports({page, perPage}));
  axios.get(`${path}?page=${page}&perPage=${perPage}`)
    .then(response => {
      const { items, pageState } = response.data.data;
      if(items.length === 0 && pageState.page !== 0){
        pageState.page = pageState.page -1;
        dispatch(fetchReports(pageState.page, perPage));
      }
      else{
        dispatch(fetchReportsSuccess(items, pageState));
      }
    })
    .catch(error => { throw error; });
};

const fetchReportsTemplates = () => dispatch => {
  dispatch(fetchingReportsTemplates());
  axios.get(`${path}/templates`)
    .then(response => {
      dispatch(fetchReportsTemplateSuccess(response.data.data));
    })
    .catch(error => {
      throw error;
    });
};

const generateReport = (reportInformation, pageState) => dispatch => {
  const { page, perPage } = pageState;
  dispatch(generatingReport());
  axios.post(`${path}`, reportInformation)
    .then(response => {
      dispatch(generateReportSuccess(response));
      dispatch(fetchReports(page, perPage));
    })
    .catch(error => {
      throw error;
    });
};

const deleteReport = (reportId, page, perPage) => dispatch => {
  axios.delete(`${path}/${reportId}`)
    .then( () => {
      dispatch(fetchReports(page, perPage));
    })
    .catch( error => {
      throw error;
    });
};

const downloadReport = file => dispatch => {
  dispatch(downloadingReport());
  downloadFile({
    file,
    url: `${assetPath}/${file.id}`,
    onComplete: () => dispatch(downloadReportSuccess())
  })(dispatch);
};

export {
  fetchReports,
  fetchReportsTemplates,
  generateReport,
  deleteReport,
  downloadReport
};



// WEBPACK FOOTER //
// ./src/redux/report/ReportActions.js